import { fetchSlackbot } from './apiClient';

export const generateSlackInstallationLink = async (): Promise<string> => {
  const response = await fetchSlackbot(
    `/slack/oauth/generate-installation-link`,
    {
      method: 'GET',
    },
  );

  if (!response.ok) {
    throw new Error(`Error: ${response.statusText}`);
  }

  const data = (await response.json()) as {
    installation_link: string;
  };

  return data.installation_link as string;
};

export const resetSlackConfiguration = async (): Promise<void> => {
  const response = await fetchSlackbot(`/reset`, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error(`Error: ${response.statusText}`);
  }
};

export const refreshPastIncidents = async (): Promise<void> => {
  const response = await fetchSlackbot(`/incidents/refresh`, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error(`Error: ${response.statusText}`);
  }
};
